import { useCallback, useEffect, useRef, useState } from "react";
import { enterOperatorMode } from "@/operatorMode";
import { clearAdminPreview } from "@/adminPreview";

export default function BoardFundraisingPaidCustomersPanel({ client, facilitated = false }) {
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [busy, setBusy] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const requests = useRef({});
  const load = useCallback(async () => {
    try {
      const response = await client.get("/admin/board-fundraising/paid-customers", { params: { kind: facilitated ? "facilitated" : "self-guided" } });
      setRows(response.data.customers); setTotal(response.data.total);
    } catch (err) { setError(err.response?.data?.detail || "Paid customers could not be loaded."); }
  }, [client, facilitated]);
  useEffect(() => { setMessage(""); setError(""); load(); }, [load]);
  const action = async (row, type) => {
    setBusy(row.session_id); setError(""); setMessage("");
    try {
      if (type === "workspace") {
        const response = await client.post(`/admin/board-fundraising/paid-customers/${encodeURIComponent(row.session_id)}/workspace`);
        sessionStorage.removeItem("fundraisingPreparationToken"); sessionStorage.removeItem("fundraisingPreparationPath");
        clearAdminPreview(); enterOperatorMode(response.data.user_id, row.organization || row.name, "Board Fundraising");
        window.location.assign(response.data.entry_route);
      } else {
        requests.current[row.session_id] ||= crypto.randomUUID();
        const response = await client.post(`/admin/board-fundraising/paid-customers/${encodeURIComponent(row.session_id)}/send-preparation`, { request_id: requests.current[row.session_id] });
        setMessage(response.data.status === "sent" ? "Organisation and individual-game preparation email sent." : "This preparation email has already been sent or is being delivered.");
        delete requests.current[row.session_id];
        load();
      }
    } catch (err) { setError(err.response?.data?.detail || "The customer action could not be completed."); }
    finally { setBusy(""); }
  };
  return <div className="bf-admin-data-view">
    <div className="bf-admin-section-heading"><div><h2>{facilitated ? "Facilitated Customers" : "Self-Guided Customers"}</h2>
      <p>{total} verified paid {facilitated ? "$2,997 facilitated" : "$497 self-guided"} purchases. Customer workspaces are created from payment details and do not depend on login.</p>
      {facilitated && <p>Preparation is emailed automatically two hours after payment. You can send the forms now using the button beside the customer.</p>}
    </div><button className="button button-back button-small" onClick={load}>Refresh</button></div>
    {error && <p role="alert" className="bf-admin-data-error">{error}</p>}{message && <p role="status">{message}</p>}
    <div className="bf-admin-table-wrap"><table className="bf-admin-table"><thead><tr><th>Customer</th><th>Email</th><th>Organisation</th><th>Paid</th>{facilitated && <th>Preparation email</th>}<th>Customer dashboard</th></tr></thead><tbody>
      {rows.map(row => <tr key={row.session_id}><td>{row.name || "Payment customer"}</td><td>{row.email || "Contact details pending"}</td><td>{row.organization || "To be completed"}</td><td>{row.paid_at ? new Date(row.paid_at).toLocaleString() : "Confirmed"}</td>
        {facilitated && <td>{row.preparation_sent_at ? new Date(row.preparation_sent_at).toLocaleString() : "Scheduled two hours after payment"}</td>}
        <td><button className="button button-small" disabled={!!busy} onClick={() => action(row, "workspace")}>Enter customer dashboard</button>{" "}
          {facilitated && <button className="button button-small button-back" disabled={!!busy} onClick={() => action(row, "send-preparation")}>Email organisation and individual game</button>}
          {row.message && <p>{row.message}</p>}
        </td></tr>)}
    </tbody></table>{!rows.length && <p>No confirmed purchases in this section yet.</p>}</div>
  </div>;
}
